module.exports = __webpack_public_path__ + "static/media/logo-small.891c15ff.svg";